



































































































































































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { VHeaders, PaginationModel, VAction } from '@/models/pagedlistmodel';
import {
  AttachmentInfoViewModel,
  GetEmailDetailModel,
  RoEmailViewModel,
} from '@/models/fixedops/repairorder';
import { VFields } from '@/models/v-fields';
import { AttachmentType } from '@/models/fixedops/attachment';
import { NewFaxViewModel } from '@/models/telephony/message';
import { FaxLine } from '@/models/admin/store';
import {
  ConversationTypes,
  MetadataType,
  MetadataKeyIdentifier,
} from '@/enums/enums';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '../common/base';
import { IDialogOption } from '@/models/dialog';
import {
  repairOrderService,
  attachmentService,
  messageService,
  storeService,
} from '@/shared';

@Component({
  components: {
    AppGrid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
  },
  props: [
    'attachments',
    'repairorder',
    'displayconfig',
    'isRoReportAttachment',
  ],
})
export default class AttachmentGridComponent extends Base {
  public attachments: AttachmentInfoViewModel[];
  public attachmentTypes: AttachmentType[] = [];
  public pagedAttachments: AttachmentInfoViewModel[] = [];
  public pagedCallLog: AttachmentInfoViewModel[] = [];
  public pagedTextLog: AttachmentInfoViewModel[] = [];

  public pagination = new PaginationModel('createdDateTime', true);
  public textPagination = new PaginationModel('createdDateTime', true);
  public callPagination = new PaginationModel('createdDateTime', true);

  public roAttachmentLoader: boolean = false;
  public isShownROAttachment: boolean = false;

  public loading: boolean = false;
  public roToggles: any = {
    attachments: true,
    callLogs: false,
    textLogs: false,
  };
  public form: any = {};
  public formFields: Array<VFields<any>> = [];
  public actions: any[] = [];
  public attachmentActions: any = [];
  public callLogActions: any[] = [];
  public repairorder: any;
  public storeId: number = 0;
  public roNumber = '';
  public tabs: any = null;
  public flags: any = {};
  public showFaxDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('repairOrderAttachments.faxDialog.title') as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-paper-plane',
      text: this.$parent.$t(
        'repairOrderAttachments.faxDialog.btnSend'
      ) as string,
    },
    loading: false,
    onAction: (): void => {
      this.sendFax();
    },
  };
  public showEmailDialog: IDialogOption = {
    width: 600,
    title: this.$parent.$t(
      'repairOrderAttachments.emailDialog.title'
    ) as string,
    model: false,
    action: {
      color: 'success',
      icon: 'fas fa-paper-plane',
      text: this.$parent.$t(
        'repairOrderAttachments.emailDialog.btnSend'
      ) as string,
    },
    loading: false,
    onAction: (): void => {
      this.sendEmail();
    },
  };
  public showTranscriptionPopup: IDialogOption = {
    width: 600,
    title: this.$parent.$t(
      'repairOrderAttachments.transcriptionDialog.title'
    ) as string,
    model: false,
  };

  public preventPaginationCall: boolean = false;
  public transcriptions: string[] = [];
  public emailModel: RoEmailViewModel = {};
  public availableFaxNumbers: FaxLine[] = [];
  public faxToSend: NewFaxViewModel = new NewFaxViewModel(
    ConversationTypes[ConversationTypes.Fax]
  );

  public isEmailDetailsLoading: boolean = false;
  public isFaxSendLoading: boolean = false;

  public headers: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.attachments.attachmentGrid.attachmentType'
      ) as string,
      value: 'attachmentTypeName',
    },
    {
      align: 'left',
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.attachments.attachmentGrid.ro'
      ) as string,
      value: 'repairOrderId',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.attachments.attachmentGrid.user'
      ) as string,
      value: 'userName',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.attachments.attachmentGrid.comment'
      ) as string,
      value: 'comment',
      filters: [
        (val: string) => {
          if (!val) return '';
          return val.match(/.{1,40}/g)?.join('\n');
        }
      ]
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.attachments.attachmentGrid.uploadedAt'
      ) as string,
      value: 'createdDateTime',
      fieldType: 'date',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.attachments.attachmentGrid.isPublic'
      ) as string,
      value: 'isPublic',
      fieldType: 'switch',
      onChange: (item) => {
        this.toggleIsPublic(item);
      },
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.attachments.attachmentGrid.actions'
      ) as string,
      sortable: false,
    },
  ];

  public attachmentHeaders: VHeaders[] = [
    {
      align: 'left',
      sortable: false,
      text: 'Attachment Type',
      value: 'attachmentTypeName',
    },
    {
      align: 'left',
      text: 'RO#',
      value: 'repairOrderId',
    },
    {
      align: 'left',
      sortable: false,
      text: 'User',
      value: 'userName',
    },
    {
      align: 'left',
      sortable: false,
      text: 'Comment',
      value: 'comment',
    },
    {
      align: 'left',
      sortable: false,
      text: 'Upload At',
      value: 'createdDateTime',
      fieldType: 'date',
    },
    {
      text: 'Actions',
      isNotDataProp: true,
      align: 'center',
      sortable: false,
    },
  ];

  public callLogHeaders: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.calls.callLogGrid.user'
      ) as string,
      value: 'userName',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.calls.callLogGrid.status'
      ) as string,
      value: 'status',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.calls.callLogGrid.from'
      ) as string,
      value: 'fromNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.calls.callLogGrid.to'
      ) as string,
      value: 'toNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.calls.callLogGrid.duration'
      ) as string,
      value: 'duration',
      filters: [
        (val) => {
          val = Number(val);
          const h = Math.floor(val / 3600);
          const m = Math.floor((val % 3600) / 60);
          const s = Math.floor((val % 3600) % 60);
          const hDisplay = h > 0 ? h + 'h ' : '';
          const mDisplay = m > 0 ? m + 'm ' : '';
          const sDisplay = s > 0 ? s + 's ' : '';
          return hDisplay + mDisplay + sDisplay;
        },
      ],
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.calls.callLogGrid.callAt'
      ) as string,
      value: 'createdDateTime',
      fieldType: 'date',
    },
    {
      align: 'center',
      isNotDataProp: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.calls.callLogGrid.actions'
      ) as string,
      sortable: false,
    },
  ];
  public textLogHeaders: VHeaders[] = [
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.texts.textLogGrid.from'
      ) as string,
      value: 'fromNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.texts.textLogGrid.to'
      ) as string,
      value: 'toNumber',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.texts.textLogGrid.text'
      ) as string,
      value: 'text',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.texts.textLogGrid.status'
      ) as string,
      value: 'status',
    },
    {
      align: 'left',
      sortable: true,
      text: this.$parent.$t(
        'repairOrderAttachments.tabs.texts.textLogGrid.messageDateTime'
      ) as string,
      value: 'createdDateTime',
      fieldType: 'date',
    },
  ];
  public beforeDestroy() {
    this.$root.$off('toggleAttachMentGridLoading', this.toggleGridLoading);
  }
  public toggleGridLoading(value: boolean): void {
    this.loading = value;
  }
  public mounted() {
    this.isShownROAttachment = this.$props.isRoReportAttachment;
    this.$root.$on('toggleAttachMentGridLoading', (value) => {
      this.toggleGridLoading(value);
    });
    if (!this.isShownROAttachment) {
      this.pagedCallLog = this.attachments.filter((r) => {
        return (
          r.attachmentTypeName === 'Voice Recording' ||
          r.attachmentTypeName === 'VoiceRecording'
        );
      });
      this.callPagination.totalItems = this.pagedCallLog.length;
      this.pagedTextLog = this.attachments.filter((r) => {
        return r.attachmentTypeName === 'Text';
      });
      this.textPagination.totalItems = this.pagedTextLog.length;
      this.pagedAttachments = this.attachments.filter((r) => {
        return (
          r.attachmentTypeName !== 'Text' &&
          r.attachmentTypeName !== 'Voice Recording' &&
          r.attachmentTypeName !== 'Voice Transcription' &&
          r.attachmentTypeName !== 'VoiceRecording'
        );
      });
    } else if (this.isShownROAttachment) {
      this.loading = true;
      this.pagedAttachments = this.attachments;
      this.loading = false;
    }
    this.pagination.totalItems = this.pagedAttachments.length;
    this.addWatch();
    this.setActions();
    if (!this.isShownROAttachment) {
      this.getAvailableFaxNumbers();
    }
  }

  public setActions() {
    this.actions = [
      {
        type: 'button',
        icon: 'fa fa-eye',
        title: this.$parent.$t(
          'repairOrderAttachments.tabs.attachments.attachmentGrid.gridActions.viewAttachment'
        ),
        loading: false,
        action: (model: AttachmentInfoViewModel, action: any) => {
          this.viewAttachment(model.id, action);
        },
      },
      {
        type: 'button',
        icon: 'fa fa-paper-plane',
        title: this.$parent.$t(
          'repairOrderAttachments.tabs.attachments.attachmentGrid.gridActions.emailAttachment'
        ),
        action: (model: AttachmentInfoViewModel) => {
          this.showEmailPopup(model);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-fax',
        title: this.$parent.$t(
          'repairOrderAttachments.tabs.attachments.attachmentGrid.gridActions.faxAttachment'
        ),
        visible: (model) => {
          return this.isFeatureToAccess('FAX');
        },
        action: (model: AttachmentInfoViewModel) => {
          this.showFaxDialog.model = true;

          this.faxToSend.recordKey = model.id.toString();
          this.faxToSend.recordIdentifier =
            MetadataType[MetadataType.Attachment];
          this.faxToSend.recordKeyIdentifier =
            MetadataKeyIdentifier[MetadataKeyIdentifier.AttachmentId];
        },
      },
    ];
    this.callLogActions = [
      {
        type: 'button',
        icon: 'fas fa-play',
        title: this.$parent.$t(
          'repairOrderAttachments.tabs.calls.callLogGrid.gridActions.playRecording'
        ),
        loading: false,
        action: (model: AttachmentInfoViewModel, action: any) => {
          this.viewAttachment(model.id, action);
        },
      },
      {
        type: 'button',
        icon: 'fas fa-file-alt',
        title: this.$parent.$t(
          'repairOrderAttachments.tabs.calls.callLogGrid.gridActions.viewRecordingTranscription'
        ),
        visible: (model: AttachmentInfoViewModel) => {
          const existing = this.attachments.find((m) => {
            return (
              m.recordingSid === model.recordingSid &&
              m.attachmentTypeName === 'Voice Transcription'
            );
          });
          if (existing) {
            return true;
          }
          return false;
        },
        loading: false,
        action: (model: AttachmentInfoViewModel, action: any) => {
          const existing = this.attachments.find((m) => {
            return (
              m.recordingSid === model.recordingSid &&
              m.attachmentTypeName === 'Voice Transcription'
            );
          });
          if (existing) {
            this.showTranscription(existing, action);
          }
        },
      },
      {
        type: 'button',
        icon: 'fa fa-paper-plane',
        title: this.$parent.$t(
          'repairOrderAttachments.tabs.calls.callLogGrid.gridActions.email'
        ),
        action: (model: AttachmentInfoViewModel) => {
          this.showEmailPopup(model);
        },
      },
    ];
    this.attachmentActions = [
      {
        type: 'button',
        icon: 'fa fa-eye',
        title: 'View Attachment',
        loading: false,
        action: (model: any, action: VAction) => {
          this.viewAttachment(model.id, action);
        },
      },
    ];
  }
  public addWatch(): void {
    this.$watch('attachments', (newVal, oldVal) => {
      if (!this.isShownROAttachment) {
        this.pagedCallLog = newVal.filter((r) => {
          return (
            r.attachmentTypeName === 'Voice Recording' ||
            r.attachmentTypeName === 'VoiceRecording'
          );
        });
        this.callPagination.totalItems = this.pagedCallLog.length;

        this.pagedTextLog = newVal.filter((r) => {
          return r.attachmentTypeName === 'Text';
        });
        this.textPagination.totalItems = this.pagedTextLog.length;

        this.pagedAttachments = newVal.filter((r) => {
          return (
            r.attachmentTypeName !== 'Text' &&
            r.attachmentTypeName !== 'Voice Recording' &&
            r.attachmentTypeName !== 'Voice Transcription' &&
            r.attachmentTypeName !== 'VoiceRecording'
          );
        });
      } else if (this.isShownROAttachment) {
        this.loading = true;
        this.pagedAttachments = newVal;
        this.loading = false;
      }
      this.pagination.totalItems = this.pagedAttachments.length;
    });
  }

  public updateAttachmentPaging(paging: any) {
    this.pagination = paging;
  }

  public updateCallLogPaging(paging: any) {
    this.callPagination = paging;
  }

  public updateTextLogPaging(paging: any) {
    this.textPagination = paging;
  }

  public async showEmailPopup(attachmentDetails): Promise<void> {
    try {
      this.showEmailDialog.model = true;
      this.showEmailDialog.loading = true;
      this.isEmailDetailsLoading = true;
      const repairOrderDetails = this.repairorder;
      const searchModel: GetEmailDetailModel = {
        advisorEmail: repairOrderDetails.advisorEmail || '',
        attachmentId: attachmentDetails.id.toString(),
        customerEmail: repairOrderDetails.customerEmail || '',
        customerKey: repairOrderDetails.customerKey,
        customerName: repairOrderDetails.customerName,
        roNumber:
          repairOrderDetails.roNumber || repairOrderDetails.repairOrderNumber,
        serviceWriterId: repairOrderDetails.serviceWriterID,
        storeName: this.repairorder.storeName,
      };

      const response = await repairOrderService.getEmailDetails(searchModel);
      this.emailModel = response;
      this.emailModel.froms = [];
      if (this.emailModel.loggedInUserEmail) {
        this.emailModel.froms = [this.emailModel.loggedInUserEmail];
      }

      if (this.emailModel.serviceAdvisorEmail) {
        this.emailModel.froms.push(this.emailModel.serviceAdvisorEmail);
      }
      this.emailModel.fromEmailUserEmail =
        this.emailModel.serviceAdvisor || this.emailModel.loggedInUserEmail;
    } finally {
      this.showEmailDialog.loading = false;
      this.isEmailDetailsLoading = false;
    }
  }

  public async getAvailableFaxNumbers(): Promise<void> {
    try {
      // this.showLoader();
      const response = await storeService.getFaxLines();
      this.availableFaxNumbers = response.results;
    } finally {
      // this.hideLoader();
    }
  }

  public async sendEmail(): Promise<void> {
    if (!this.emailModel.customerEmail1) {
      this.showAlert(
        false,
        this.$t(
          'repairOrderAttachments.emailDialog.alertCustomerEmailCannotEmpty'
        )
      );
      return;
    }
    try {
      this.showEmailDialog.loading = true;
      await repairOrderService.sendEmail(this.emailModel);
      this.showEmailDialog.model = false;
      this.showAlert(
        true,
        this.$t('repairOrderAttachments.emailDialog.alertSendAttachment')
      );
    } finally {
      this.showEmailDialog.loading = false;
    }
  }

  public async sendFax(): Promise<void> {
    if (!this.faxToSend.from || this.faxToSend.from.trim() === '') {
      this.showAlert(
        false,
        this.$t('repairOrderAttachments.faxDialog.alertFillValidFromFaxNumber')
      );
      return;
    }

    if (!this.faxToSend.to || this.faxToSend.to.trim() === '') {
      this.showAlert(
        false,
        this.$t('repairOrderAttachments.faxDialog.alertFillValidToFaxNumber')
      );
      return;
    }

    try {
      this.showFaxDialog.loading = true;
      await messageService.sendFax(this.faxToSend);
      this.showFaxDialog.model = false;
      this.showAlert(
        true,
        this.$t('repairOrderAttachments.faxDialog.alertSendAttachment')
      );
    } finally {
      this.showFaxDialog.loading = false;
    }
  }

  public setToggle(prop: string): void {
    const keys = Object.keys(this.roToggles);
    this.roToggles[prop] = !this.roToggles[prop];
    keys.forEach((key) => {
      if (key !== prop) {
        this.roToggles[key] = false;
      }
    });
  }

  public async showTranscription(
    model: AttachmentInfoViewModel,
    action: any
  ): Promise<void> {
    try {
      action.loading = true;
      const response = await repairOrderService.getTranscription(
        model.attachmentUri
      );
      if (response) {
        this.transcriptions = response.split('Speaker');
        this.showTranscriptionPopup.model = true;
      }
    } finally {
      action.loading = false;
    }
  }

  public toggleIsPublic(item: any): void {
    if (item.isPublic) {
      this.togglePublic(item.id, true);
    } else {
      this.togglePublic(item.id, false);
    }
  }

  public switchChanged(item: any): void {
    if (item.isPublic) {
      this.togglePublic(item.id, true);
    } else {
      this.togglePublic(item.id, false);
    }
  }

  public async togglePublic(id: string, status: boolean): Promise<void> {
    try {
      this.showLoader();
      await attachmentService.toggleIsPublicAsync(id, status);
      this.showAlert(
        true,
        this.$t(
          'repairOrderAttachments.tabs.attachments.alertAttachmentUpdated'
        )
      );
    } finally {
      this.hideLoader();
    }
  }

  public async viewAttachment(
    attachmentId: string,
    action: any
  ): Promise<void> {
    try {
      action.loading = true;
      this.roAttachmentLoader = true;
      await attachmentService.viewAttachmentAsync(attachmentId);
    } finally {
      this.roAttachmentLoader = false;
      action.loading = false;
    }
  }
}

